var _rect, _rect2, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g3, _g4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g5, _g6, _g7, _g8, _path35, _path36, _path37, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGbNir = function SvgGbNir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 480,
    width: 640,
    rx: 0,
    ry: 0,
    fill: "#fff",
    fillRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "a",
    y: 192,
    ry: 0,
    rx: 0,
    height: 96,
    width: 640,
    fill: "#c00",
    fillRule: "evenodd"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: 300,
    width: 600,
    transform: "matrix(0 .75 -1 0 560 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.205 146.61c3.08-4.82 1.239-7.933-3.42-8.895 0 0-14.867 4.766-30.924 5.289-16.056.523-35.132-4.038-35.132-4.038-3.421 2.147-2.586 7.241-.89 10.421 0 0 16.809 5.584 35.944 5.036 12.153-.348 23.67-3.45 30.13-5.505 3.712-1.18 4.294-2.254 4.292-2.308z",
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.522
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 357.552l-30.857-64.106-70.946 5.33L258.285 240l-40.088-58.776 70.946 5.33L320 122.448l30.857 64.106 70.946-5.33L381.715 240l40.088 58.776-70.946-5.33z",
    fill: "#fff",
    stroke: "#161111",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.54 122.228c38.763 6.39 37.378 8.2 37.378 8.2l10.117-30.245s1.065-5.963-1.704-9.584c-2.769-3.62-10.543-1.597-10.543-1.597s-1.065-4.899-4.472-6.07c-3.408-1.172-16.08 4.579-20.021 5.857-3.94 1.278-5.964 2.556-11.501 2.45-5.538-.107-15.442-5.006-17.252-5.965-1.81-.958-4.473-1.916-6.922-1.81-2.45.107-5.005.746-6.283 2.45-1.278 1.703-1.278 3.833-1.278 3.833s-2.024-1.278-5.218-1.278c-3.195 0-5.006.426-6.497 2.13-1.49 1.704-3.407 6.496-3.407 6.496l3.62 8.2.213 11.288 7.561 11.928 36.208-6.283z",
    fill: "#b02320",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.304
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.674 139.315s1.952 2.327 1.877 3.153c-.075.825-.901 1.576-.901 1.576s.6.6.45 1.502c-.15.9-1.35.975-1.35.975s.224.826-.526 1.202c-.751.375-3.829 1.05-3.829 1.05s-15.014-4.278-31.078-4.278c-16.065 0-34.983 5.18-34.983 5.18s-1.951-.676-2.026-1.952c-.075-1.277.225-2.177.225-2.177s-1.069.11-1.351-.826c-.396-1.31.15-2.327.15-2.327s-.745.24.075-1.502c.6-1.276 1.501-1.726 1.501-1.726s16.815-6.006 35.958-6.08c19.143-.076 35.808 6.08 35.808 6.23z",
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.522
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.229 101.495s-.641-2.18.769-4.102c1.41-1.923 3.974-1.795 4.744-1.41.769.384.64 1.282 1.666 1.538 1.026.256 1.795-.513 1.795-.513",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.147
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.824 106.598l-5.822 12.046-2.289.402s-1.396-.84-5.38-.562c-2.851.2-3.694.923-3.694.923l5.18-12.006s.403 2.58 1.003 4.096c.763 1.927 3.654 3.734 3.654 3.734s.4-2.305-.361-5.1c-.843-3.091-2.81-7.267-2.81-7.267l10.52 3.734z",
    fill: "#fc0",
    fillOpacity: 0.941,
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#121116",
    stroke: "#121116",
    strokeWidth: 1.17,
    strokeLinejoin: "round",
    d: "M316.492 69.161h6.516v27.694h-6.516z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.56 120.235l4.185 8.955s17.81-6.943 38.833-6.813c31.534.194 40.489 6.52 40.489 6.52l4.671-11.095-3.503 2.044-3.602 2.239-4.087 1.557-4.964-.39-4.38-3.211-2.238-4.672-3.699 3.407-6.52 1.46-6.424-1.655-5.645-7.105s-4.205 7.898-9.539 8.37c-7.688.681-12.165-3.698-12.165-3.698s-2.859 6.423-7.592 7.591c-7.494 1.85-13.723-3.504-13.82-3.504z",
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.991
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.243
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.447 65.647c0 1.881-1.502 3.407-3.358 3.411-1.856.004-3.365-1.516-3.372-3.398-.007-1.881 1.49-3.413 3.345-3.424 1.856-.012 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.515 67.399s2.72-.047 2.996-1.153c.277-1.106-.184-2.535-.184-2.535s1.29 1.429.922 2.535c-.37 1.106-.73 1.392-1.66 1.614-.63.15-1.567-.093-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.272 69.469c0 1.881-1.503 3.407-3.359 3.411-1.856.004-3.365-1.516-3.372-3.398-.007-1.881 1.49-3.414 3.345-3.425 1.856-.01 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.339 71.22s2.72-.046 2.996-1.152c.277-1.107-.184-2.536-.184-2.536s1.29 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.94 63.406c0 1.88-1.503 3.407-3.36 3.41-1.855.005-3.364-1.516-3.371-3.397-.008-1.881 1.49-3.414 3.345-3.425 1.856-.01 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.007 65.157s2.72-.046 2.996-1.152c.277-1.107-.184-2.536-.184-2.536s1.29 1.43.922 2.536c-.37 1.106-.73 1.392-1.66 1.613-.63.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.631 65.557c0 1.881-1.502 3.408-3.358 3.411-1.856.004-3.365-1.516-3.372-3.398-.008-1.88 1.489-3.413 3.345-3.424 1.856-.011 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.698 67.309s2.72-.046 2.997-1.153c.277-1.106-.184-2.535-.184-2.535s1.29 1.429.922 2.535c-.37 1.107-.731 1.393-1.66 1.614-.63.15-1.567-.093-2.075-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78 72.272c0 1.881-1.502 3.408-3.358 3.411-1.856.004-3.365-1.516-3.372-3.398-.007-1.88 1.49-3.413 3.345-3.424 1.856-.011 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.848 74.024s2.72-.046 2.996-1.153c.277-1.106-.184-2.535-.184-2.535s1.29 1.429.922 2.535c-.369 1.107-.73 1.393-1.66 1.614-.63.15-1.567-.092-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.3 83.29c0 1.881-1.502 3.407-3.358 3.411-1.856.004-3.364-1.516-3.372-3.398-.007-1.881 1.49-3.413 3.346-3.424 1.856-.012 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.368 85.042s2.72-.047 2.997-1.153c.276-1.106-.185-2.535-.185-2.535s1.291 1.429.922 2.535c-.369 1.106-.73 1.392-1.66 1.614-.629.15-1.567-.093-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.997 94.438c0 1.881-1.503 3.408-3.359 3.411-1.856.004-3.364-1.516-3.371-3.397-.008-1.882 1.489-3.414 3.345-3.425 1.856-.011 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.064 96.19s2.72-.046 2.997-1.153c.276-1.106-.185-2.535-.185-2.535s1.291 1.429.922 2.535c-.368 1.107-.73 1.393-1.66 1.614-.629.15-1.567-.092-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.042 104.217c0 1.882-1.502 3.408-3.358 3.412-1.856.003-3.365-1.517-3.372-3.398-.008-1.882 1.49-3.414 3.345-3.425 1.856-.011 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11 105.969s2.72-.046 2.996-1.153c.277-1.106-.184-2.535-.184-2.535s1.29 1.43.922 2.535c-.37 1.107-.73 1.393-1.66 1.614-.63.15-1.567-.092-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.318 72.402c0 1.882-1.503 3.408-3.359 3.412-1.856.003-3.364-1.517-3.372-3.398-.007-1.882 1.49-3.414 3.346-3.425 1.856-.011 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.385 74.154s2.72-.046 2.997-1.152c.276-1.107-.185-2.536-.185-2.536s1.291 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.15 71.53c0 1.573-1.256 2.85-2.808 2.853-1.552.003-2.814-1.269-2.82-2.842-.006-1.573 1.246-2.855 2.798-2.864 1.552-.01 2.818 1.257 2.83 2.83",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16978112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.026 72.995s2.274-.039 2.506-.964c.23-.925-.155-2.12-.155-2.12s1.08 1.195.771 2.12c-.308.925-.61 1.164-1.387 1.35-.527.124-1.311-.078-1.735-.386z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.183 75.075c0 1.574-1.256 2.85-2.808 2.853-1.552.003-2.814-1.268-2.82-2.841-.006-1.574 1.245-2.855 2.797-2.864 1.552-.01 2.819 1.257 2.831 2.83",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16978112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.058 76.54s2.275-.038 2.506-.964c.231-.925-.154-2.12-.154-2.12s1.08 1.195.77 2.12c-.307.926-.61 1.165-1.387 1.35-.526.125-1.31-.077-1.735-.386z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.379 80.29c0 1.574-1.257 2.85-2.809 2.854-1.552.003-2.813-1.268-2.82-2.842-.006-1.573 1.246-2.855 2.798-2.864 1.552-.01 2.819 1.257 2.83 2.83",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16978112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.254 81.756s2.274-.039 2.506-.964c.231-.925-.154-2.12-.154-2.12s1.079 1.195.77 2.12c-.308.925-.61 1.164-1.387 1.35-.527.125-1.311-.078-1.735-.386z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.67 85.832c0 1.702-1.359 3.082-3.037 3.086-1.679.003-3.043-1.372-3.05-3.073-.006-1.702 1.347-3.088 3.026-3.098 1.678-.01 3.048 1.36 3.061 3.061",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.1697663999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.21 87.417s2.459-.042 2.71-1.043c.25-1-.168-2.293-.168-2.293s1.168 1.293.834 2.293c-.333 1-.66 1.26-1.5 1.46-.57.135-1.418-.084-1.877-.417z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.995 93.265c0 1.88-1.503 3.407-3.358 3.41-1.856.005-3.365-1.516-3.372-3.397-.008-1.881 1.489-3.414 3.345-3.425 1.856-.01 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.062 95.016s2.72-.046 2.997-1.152c.276-1.107-.184-2.536-.184-2.536s1.29 1.43.921 2.536c-.368 1.106-.73 1.392-1.66 1.613-.629.15-1.566-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.388
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.658 108.517c0 1.767-1.411 3.2-3.154 3.204-1.743.003-3.16-1.424-3.167-3.191-.007-1.767 1.399-3.206 3.142-3.216 1.743-.01 3.165 1.411 3.179 3.178",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.1696901599999998
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.025 110.162s2.555-.043 2.815-1.082c.26-1.039-.174-2.381-.174-2.381s1.213 1.342.866 2.381c-.346 1.04-.686 1.308-1.558 1.515-.591.141-1.472-.086-1.949-.433z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.552 72.312c0 1.881-1.502 3.407-3.358 3.411-1.856.004-3.365-1.516-3.372-3.398-.008-1.881 1.49-3.413 3.345-3.424 1.856-.012 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62 74.064s2.72-.047 2.996-1.153c.277-1.106-.184-2.535-.184-2.535s1.29 1.429.922 2.535c-.37 1.106-.731 1.392-1.66 1.614-.63.15-1.567-.093-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M305.209 69.021c0 1.882-1.503 3.408-3.359 3.412-1.856.004-3.364-1.517-3.372-3.398-.007-1.881 1.49-3.414 3.346-3.425 1.856-.01 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.276 70.773s2.72-.046 2.997-1.152c.276-1.107-.185-2.536-.185-2.536s1.291 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.218 65.261c0 1.881-1.503 3.408-3.359 3.411-1.856.004-3.364-1.516-3.372-3.397-.007-1.882 1.49-3.414 3.346-3.425 1.856-.011 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.285 67.013s2.72-.046 2.997-1.153c.276-1.106-.185-2.535-.185-2.535s1.291 1.429.922 2.535c-.368 1.107-.73 1.393-1.66 1.614-.629.15-1.567-.092-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M288.052 63.263c0 1.882-1.503 3.408-3.359 3.412-1.856.003-3.364-1.517-3.372-3.398-.007-1.882 1.49-3.414 3.346-3.425 1.856-.011 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12 65.015s2.72-.046 2.996-1.152c.276-1.107-.185-2.536-.185-2.536s1.291 1.43.922 2.536c-.368 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.24 65.849c0 1.881-1.502 3.407-3.358 3.411-1.856.004-3.364-1.516-3.372-3.398-.007-1.881 1.49-3.413 3.346-3.425 1.856-.01 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.308 67.6s2.72-.046 2.997-1.152c.276-1.106-.185-2.536-.185-2.536s1.291 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.602 73.487c0 1.881-1.502 3.408-3.358 3.411-1.856.004-3.365-1.516-3.372-3.398-.007-1.88 1.49-3.413 3.345-3.424 1.856-.011 3.37 1.503 3.385 3.384",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.67 75.239s2.72-.046 2.996-1.153c.277-1.106-.184-2.535-.184-2.535s1.29 1.429.922 2.535c-.369 1.107-.73 1.393-1.66 1.614-.63.15-1.567-.093-2.074-.461z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.43 84.18c0 1.882-1.503 3.408-3.359 3.412-1.856.004-3.365-1.516-3.372-3.398-.007-1.881 1.49-3.414 3.345-3.425 1.856-.01 3.37 1.503 3.386 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.497 85.932s2.72-.046 2.996-1.152c.277-1.107-.184-2.536-.184-2.536s1.29 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M267.84 95.344c0 1.882-1.503 3.408-3.359 3.412-1.856.003-3.364-1.517-3.372-3.398-.007-1.882 1.49-3.414 3.346-3.425 1.856-.011 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.907 97.096s2.72-.046 2.997-1.152c.276-1.107-.185-2.536-.185-2.536s1.291 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.629.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.01 105.45c0 1.882-1.502 3.408-3.358 3.412-1.856.003-3.365-1.517-3.372-3.398-.007-1.881 1.49-3.414 3.345-3.425 1.856-.01 3.37 1.503 3.385 3.385",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.16983665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.078 107.202s2.72-.046 2.996-1.152c.277-1.107-.184-2.536-.184-2.536s1.29 1.43.922 2.536c-.369 1.106-.73 1.392-1.66 1.613-.63.15-1.567-.092-2.074-.46z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.832
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.31597 -.08466 .13499 .50378 109.39 30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.318 120.676s1.636-.486 1.517-1.6c-.118-1.113-.767-2.419-.767-2.419s1.151 1.17 1.214 2.3c.063 1.128-.082 1.463-.587 1.827-.343.247-.974.166-1.377-.108z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.832
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.31758 .0784 -.125 .50636 259.933 -40.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.342 119.795s1.667.364 2.101-.669c.434-1.032.495-2.489.495-2.489s.444 1.581-.046 2.6c-.49 1.019-.778 1.242-1.397 1.317-.42.051-.932-.325-1.153-.76z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M316.722 53.812l.243 5.699s-6.757.593-7.033 1.212c-1.313 2.943 1.576 6.912 1.576 6.912s2.272-1.698 8.003-1.698c5.457 0 8.246 1.334 8.246 1.334s1.455-2.304 1.455-4.001c0-1.698-.606-3.396-.606-3.396s-2.79-.363-3.638-.363h-2.425l-.243-5.82-5.578.12z",
    fill: "#b3a192",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.17
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M326.359 62.653c0 .64-.54 1.158-1.207 1.16-.667 0-1.209-.516-1.211-1.155-.003-.639.535-1.16 1.201-1.163.667-.004 1.212.51 1.217 1.149M329.144 63.274c0 .667-.563 1.208-1.26 1.21-.695 0-1.26-.538-1.264-1.205-.003-.667.559-1.21 1.255-1.214.695-.004 1.263.532 1.269 1.2M323.57 62.609c0 .639-.54 1.158-1.207 1.159-.666.001-1.209-.515-1.211-1.154-.003-.64.535-1.16 1.201-1.164.667-.004 1.212.51 1.217 1.15M317.98 62.672c0 .665-.56 1.204-1.255 1.206-.694.001-1.258-.536-1.26-1.201-.004-.665.556-1.207 1.25-1.211.694-.004 1.26.531 1.266 1.196M314.878 62.879c0 .665-.561 1.204-1.255 1.206-.694.001-1.259-.536-1.261-1.201-.003-.665.556-1.207 1.25-1.211.694-.004 1.26.531 1.266 1.196M320.573 59.39c0 .56-.474 1.016-1.06 1.017-.585.001-1.06-.452-1.063-1.013-.002-.561.47-1.018 1.055-1.022.585-.003 1.063.448 1.068 1.01M320.573 54.66c0 .562-.474 1.017-1.06 1.018-.585.001-1.061-.452-1.063-1.013-.002-.561.47-1.018 1.055-1.022.585-.003 1.063.448 1.068 1.01M320.573 57.207c0 .561-.474 1.016-1.06 1.017-.585.002-1.06-.452-1.063-1.013-.002-.56.47-1.018 1.055-1.021.585-.004 1.063.448 1.068 1.009M311.734 63.723c0 .642-.542 1.163-1.212 1.164-.67.002-1.214-.517-1.217-1.159-.003-.641.538-1.164 1.207-1.168.67-.004 1.217.513 1.222 1.154",
    fill: "#f0ddcb",
    stroke: "#121116",
    strokeWidth: 0.596,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M320.845 62.36c0 .702-.595 1.272-1.331 1.273-.736.002-1.334-.565-1.336-1.268-.003-.702.59-1.274 1.325-1.278.736-.004 1.336.561 1.342 1.263",
    fill: "#916c68",
    stroke: "#4d3126",
    strokeWidth: 0.596,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.534
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.063 45.45c0 1.392-1.112 2.521-2.486 2.524-1.374.003-2.49-1.122-2.496-2.514-.005-1.393 1.103-2.527 2.476-2.535 1.374-.008 2.495 1.112 2.506 2.505",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeWidth: 1.169966,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.412 46.746s2.013-.034 2.218-.853c.204-.819-.137-1.876-.137-1.876s.955 1.057.683 1.876c-.273.819-.541 1.03-1.229 1.194-.466.111-1.16-.068-1.535-.341z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.967 130.135s2.222 2.074 2.815 3.926c.592 1.852 1.481 6.815 1.481 6.815s23.259-6.444 34.666-5.926c11.407.519 37.702 6.296 37.702 6.296s.444-2.815.963-5.777c.518-2.963 2.666-6.222 2.666-6.222s-25.11-7.852-40.961-7.111c-15.851.74-23.777 2.444-27.332 3.555-3.556 1.111-12.222 4.519-12 4.444z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.522
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.661 36.048h10.004s-2.469 1.708-2.971 3.334c-.432 1.4-.303 3.699-.303 3.699s2.728 0 3.94-1.031c1.213-1.03 3.76-2.85 3.76-2.85v12.732s-2.456-2.374-3.941-3.152a14.443 14.443 0 0 0-3.577-1.274s0 2.062.848 3.274c.85 1.213 4.244 5.82 4.244 5.82l-14.308.546s3.394-3.578 4.79-6.184c.91-1.697.545-3.456.545-3.456s-2.425 0-3.637.85c-1.213.848-3.335 3.394-3.335 3.394V39.504s.91 2.364 2.91 3.273c2.001.91 3.88.425 3.88.425s.389-2.437-.424-3.941c-.838-1.55-2.607-3.274-2.425-3.213z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.17
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M313.877 76.449s-7.116-.086-13.204-3.687c-6.088-3.601-12.228-7.373-21.264-5.23-1.85.438-8.66 3.43-11.66 13.118-2.106 6.798.342 15.004 2.486 18.691 2.144 3.687 5.6 7.424 5.6 7.424l3.676-2.49s-9.362-7.935-8.247-18.224c1.115-10.288 6.259-12.69 6.259-12.69s6.345-4.972 14.833-.256c8.489 4.715 16.805 6.859 16.805 6.859s7.803 1.886 8.489 1.8c.686-.085-3.944-5.401-3.773-5.315z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.17
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M274.515 115.04l-3.78-7.433 11.343-4.433s-2.738 3.65-3.39 6.259c-.796 3.185-.522 5.867-.522 5.867s1.043-.782 2.347-2.868c.99-1.584 2.608-7.302 2.608-7.302l5.085 16.298c.04.044-2.614-2.614-4.48-2.93-2.103-.355-4.647.323-4.647.323l-2.999.912-1.565-4.694z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M326.703 76.314s7.117-.085 13.204-3.686c6.088-3.602 12.228-7.373 21.264-5.23 1.85.438 8.66 3.429 11.66 13.118 2.106 6.798-.342 15.004-2.486 18.691-2.143 3.687-3.601 5.856-3.601 5.856l-4.419-1.587s8.106-7.27 6.991-17.559c-1.114-10.289-6.259-12.69-6.259-12.69s-6.345-4.972-14.833-.256c-8.488 4.715-16.805 6.859-16.805 6.859s-7.803 1.886-8.489 1.8c-.685-.085 3.945-5.401 3.773-5.316z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.17
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#121116",
    strokeWidth: 1.17,
    strokeLinejoin: "round",
    d: "M323.028 69.272h2.971v27.707h-2.971zM313.024 69.151h3.516v27.707h-3.516z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M329.212 62.724c0 4.915-4.331 8.903-9.681 8.913-5.35.01-9.699-3.962-9.72-8.877-.021-4.915 4.293-8.919 9.643-8.948 5.35-.029 9.715 3.927 9.758 8.842",
    fill: "#fc0",
    stroke: "#121116",
    strokeWidth: 1.17,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M310.907 96.747l16.681-.137s-1.956 1.167-3.638 4.153c-1.682 2.986-1.442 4.874-1.442 4.874s2.54-.034 4.325-1.339c1.785-1.304 3.776-3.741 3.776-3.741l-.069 15.377s-1.201-1.956-3.192-3.123c-1.99-1.167-4.805-1.167-4.805-1.167h-5.698s-2.605.154-3.776.926c-1.65 1.09-3.707 3.193-3.707 3.193l-.274-14.52s.823 2.54 3.5 3.57c2.678 1.03 4.188.893 4.188.893s0-3.261-1.373-4.943c-1.373-1.682-4.496-3.947-4.496-4.016z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.991
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M320.201 108.821s2.441 5.695 5.279 8.209c1.652 1.463 6.619 2.565 8.864 1.992 5.047-1.289 8.515-5.326 8.515-5.326s-.18 4.423 2.979 6.86c3.16 2.437 5.687 3.07 8.304 2.347 2.618-.722 10.02-6.228 10.02-6.228l1.535 1.354s-4.245 4.122-8.707 6.31c-2.297 1.127-9.27.501-11.527-1.304-2.257-1.806-3.597-6.18-3.597-6.18s-1.39 2.812-4.368 3.805c-2.98.993-7.073.95-10.874-.16-2.558-.748-5.881-4.277-6.513-5.45-.632-1.174-.451-1.806-.451-1.806s-1.875 5.373-5.777 6.84c-3.686 1.383-7.887 1.394-11.457.368-3.608-1.038-3.89-3.055-3.89-3.055s-.27 5.687-8.123 7.311c-7.854 1.625-14.082-4.152-14.082-4.152l1.083-1.625s4.423 4.965 11.193 4.514c6.77-.452 9.027-9.117 9.027-9.117s2.979 4.513 10.923 4.603c7.943.09 10.2-10.29 10.2-10.29l1.444.18z",
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.939
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.629 112.134s.06-2.764.654-3.595c.842-1.178 1.989-1.226 2.574-1.062.721.202 1.47.858 1.348 2.778-.123 1.92-.654 2.86-.082 3.595.572.736.654 1.226 1.757 1.062 1.103-.163 1.593-.53 1.348-1.552-.245-1.022-.572.082-.776-.776-.204-.858 1.067-4.565.858-6.864-.204-2.247-1.062-4.045-2.778-4.495-1.613-.422-2.983-.408-4.495.695-1.45 1.058-3.309 4.535-3.309 4.535l-.04 7.436 3.023-.163-.082-1.594z",
    fillRule: "evenodd",
    strokeWidth: 1.14741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.997 114.136s-1.157-2.512-2.033-3.037c-1.242-.745-2.313-.332-2.784.052-.58.473-1.007 1.373-.129 3.085.878 1.712 1.74 2.362 1.508 3.265-.232.902-.111 1.385-1.188 1.674-1.077.29-1.673.148-1.855-.886-.183-1.035.557-.153.402-1.022-.154-.868-2.798-3.76-3.522-5.953-.709-2.142-.638-4.133.756-5.229 1.311-1.03 2.573-1.563 4.4-1.154 1.75.392 4.842 2.84 4.842 2.84l3.001 6.804-2.838 1.055-.56-1.494z",
    fillRule: "evenodd",
    strokeWidth: 1.14741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.419 92.114s-2.942 4.944-2.288 8.744c.653 3.8 4.576 11.97 4.576 11.97l.04 1.104 2.117-.229-.482-1.12s1.057-9.781.408-12.87c-.482-2.295-4.33-7.558-4.371-7.599zM299.117 114.749s1.47 1.759 3.228 2.615c1.92.935 2.71.941 3.473.368.559-.42.367-2.207-.286-2.697-.654-.49-1.396-.241-1.512.245-.197.821-.464.766-1.062.45-.873-.463-2.901-1.716-2.901-1.716l-.94.735zM296.84 115.148s-.619 2.207-1.87 3.71c-1.368 1.64-2.085 1.97-3.016 1.76-.683-.154-1.241-1.861-.846-2.577.395-.715 1.173-.792 1.48-.397.515.669.737.509 1.152-.026.607-.78 1.941-2.755 1.941-2.755l1.16.285z",
    fillRule: "evenodd",
    strokeWidth: 1.14741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.445 113.372c.108.645-1.838 1.509-4.349 1.931-2.51.423-4.639.244-4.757-.398-.118-.643 1.82-1.508 4.33-1.933 2.51-.425 4.646-.25 4.774.391",
    strokeLinejoin: "round",
    strokeWidth: 1.14741
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.636 113.242s1.025-2.568 1.873-3.138c1.202-.808 2.293-.45 2.783-.092.605.442 1.076 1.32.288 3.074-.788 1.756-1.615 2.45-1.337 3.339.278.89.182 1.377 1.273 1.61 1.09.234 1.678.062 1.807-.98.128-1.043-.565-.125-.455-1 .11-.875 2.6-3.9 3.21-6.127.597-2.176.424-4.16-1.025-5.183-1.363-.961-2.65-1.428-4.453-.925-1.729.482-4.69 3.086-4.69 3.086l-2.645 6.95 2.889.907.482-1.521z",
    fillRule: "evenodd",
    strokeWidth: 1.14741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66 113.141s-.203-2.758-.839-3.557c-.902-1.133-2.05-1.121-2.625-.928-.71.24-1.425.933-1.203 2.845.221 1.91.8 2.822.267 3.586-.533.764-.59 1.258-1.7 1.152-1.11-.107-1.618-.449-1.426-1.481.192-1.033.575.052.735-.816.16-.867-1.302-4.503-1.212-6.81.088-2.255.852-4.094 2.543-4.632 1.589-.505 2.957-.562 4.524.462 1.503.982 3.54 4.358 3.54 4.358l.424 7.424-3.028-.007v-1.596z",
    fillRule: "evenodd",
    strokeWidth: 1.14741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84 92.316s-4.488 3.598-5.208 7.385c-.72 3.788.087 12.816.087 12.816l-.349 1.047 2.063.528-.06-1.217s4.421-8.79 4.897-11.91c.353-2.318-1.406-8.597-1.43-8.65zM343.303 115.16s.76 2.163 2.106 3.581c1.47 1.55 2.207 1.832 3.123 1.562.671-.197 1.118-1.937.678-2.625-.44-.689-1.222-.715-1.502-.3-.472.7-.703.554-1.152.047-.656-.74-2.115-2.624-2.115-2.624l-1.138.36zM341.03 114.736s-1.353 1.85-3.052 2.817c-1.856 1.057-2.643 1.114-3.442.591-.585-.383-.509-2.178.112-2.71.62-.53 1.377-.33 1.524.148.25.807.513.735 1.09.38.84-.518 2.783-1.9 2.783-1.9l.986.674z",
    fillRule: "evenodd",
    strokeWidth: 1.14741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.902 115.038c-.125.641-2.25.768-4.75.283-2.499-.485-4.43-1.398-4.315-2.041.115-.643 2.233-.774 4.733-.292 2.5.483 4.439 1.396 4.334 2.04",
    strokeLinejoin: "round",
    strokeWidth: 1.14741
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M279.09 129.87s.487 2.045 1.655.974c1.167-1.07 17.227-7.397 39.904-7.397 22.677 0 37.568 6.23 38.444 6.619.876.389 1.266.876 2.044 0 .779-.876-.778-2.239-.778-2.239s-15.767-6.716-40.391-6.618c-24.624.097-40.586 7.105-40.586 7.105s-1.07.778-.292 1.557z",
    fill: "#cca715",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.522
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M307.846 139.304s.724-2.012 1.987-2.399c1.007-.308 2.598.682 2.598.682s-1.916-.176-2.516.165c-.541.308-.705 1.223-.705 1.223s.411-.73 1.881-.659c1.47.07 1.634.07 1.634.07s-2.492.189-3.068.906c-.576.717 2.351 1.046 2.351 1.046s-4.48.024-5.067-.247c-.588-.27-.964-1.187-1.964-.905-.999.282-2.022 1.176-2.022 1.176s1.14-1.917 1.858-1.928c.717-.012 1.14-.047 1.787.247.647.293 1.246.623 1.246.623zM291.097 142.932s.339-2.11 1.509-2.725c.933-.49 2.68.19 2.68.19s-1.917.181-2.443.627c-.475.403-.467 1.332-.467 1.332s.27-.792 1.727-.995a68.51 68.51 0 0 0 1.62-.233s-2.416.646-2.85 1.457c-.433.812 2.505.594 2.505.594s-4.398.851-5.025.694c-.628-.157-1.167-.988-2.097-.526-.93.462-1.77 1.529-1.77 1.529s.766-2.094 1.469-2.238c.703-.145 1.112-.257 1.802-.088.69.17 1.34.382 1.34.382zM321.972 138.56s.84-1.966 2.123-2.28c1.024-.249 2.554.832 2.554.832s-1.903-.287-2.52.019c-.56.276-.776 1.18-.776 1.18s.453-.704 1.916-.549c1.463.156 1.627.165 1.627.165s-2.499.044-3.115.726c-.617.683 2.286 1.181 2.286 1.181s-4.473-.236-5.044-.54c-.571-.304-.894-1.241-1.908-1.017-1.014.223-2.086 1.056-2.086 1.056s1.25-1.847 1.966-1.817c.716.03 1.14.019 1.77.35.628.33 1.207.694 1.207.694zM336.116 140.16s1.062-1.855 2.374-2.016c1.045-.129 2.44 1.124 2.44 1.124s-1.857-.507-2.507-.276c-.587.209-.907 1.081-.907 1.081s.532-.646 1.967-.32c1.435.324 1.597.353 1.597.353s-2.487-.248-3.18.358c-.691.605 2.134 1.44 2.134 1.44s-4.415-.757-4.947-1.126c-.532-.368-.742-1.337-1.776-1.233-1.033.104-2.196.806-2.196.806s1.457-1.689 2.165-1.576c.709.114 1.131.153 1.717.555.586.401 1.119.83 1.119.83zM350.16 142.667s.99-1.412 2.055-1.446c.85-.027 1.879 1.082 1.879 1.082s-1.455-.544-1.994-.405c-.487.125-.808.802-.808.802s.475-.48 1.604-.114c1.129.367 1.257.402 1.257.402s-1.98-.382-2.58.054c-.601.436 1.608 1.313 1.608 1.313s-3.492-.931-3.893-1.266c-.4-.336-.499-1.13-1.336-1.121-.838.008-1.824.486-1.824.486s1.294-1.25 1.855-1.107c.56.143.898.205 1.339.57.441.367.838.75.838.75z",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.022 129.722c.338 1.676-1.634 3.485-4.402 4.04-2.768.554-5.283-.356-5.617-2.033-.338-1.675 1.633-3.484 4.401-4.038 2.768-.555 5.284.355 5.618 2.031z",
    fill: "#0f6545",
    stroke: "#000",
    strokeWidth: 0.697,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M298.753 129.448c.081.407-.347.835-.956.957-.61.122-1.17-.108-1.25-.515-.082-.406.346-.834.955-.956.61-.122 1.17.108 1.25.515z",
    fill: "#cecfc1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344.14 131.75c-.51 1.631-3.108 2.268-5.802 1.423-2.693-.846-4.46-2.854-3.947-4.484.51-1.632 3.108-2.269 5.802-1.423 2.693.845 4.46 2.853 3.947 4.484z",
    fill: "#0f6545",
    stroke: "#000",
    strokeWidth: 0.697,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M338.776 128.493c-.124.395-.705.565-1.298.379-.593-.186-.973-.657-.849-1.053.124-.395.705-.564 1.298-.378.593.186.973.657.849 1.052z",
    fill: "#cecfc1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f2d86",
    stroke: "#000",
    strokeWidth: 0.991,
    strokeLinejoin: "round",
    d: "M314.603 125.943h10.14v5.112h-10.14z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M318.877 127.033c0 .231-.432.419-.964.419s-.963-.188-.963-.42c0-.23.431-.418.963-.418s.964.187.964.419z",
    fill: "#707c8b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.944 131.055l1.676 4.944-3.1 1.676s-1.425 1.006-2.85.251c-1.424-.754-2.264-3.013-1.508-3.938 1.501-1.836 5.782-3.017 5.782-2.933z",
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.522
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M283.347 134.575c0 .833-.638 1.509-1.425 1.509s-1.425-.676-1.425-1.51c0-.833.638-1.509 1.425-1.509s1.425.676 1.425 1.51z",
    fill: "#8f322f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M281.999 133.984c.044.266-.019.53-.163.69a.418.418 0 0 1-.538.087c-.189-.106-.331-.335-.374-.601-.044-.267.018-.53.163-.69a.418.418 0 0 1 .538-.088c.188.106.33.336.374.602z",
    fill: "#e2a494"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M353.88 131.699l-1.665 4.403 3.947 2.067s1.745.779 2.846-.188c.941-.826 1.155-2.738.403-3.705-.712-.915-5.585-2.604-5.531-2.577z",
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.522
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M358.605 135.23c0 .54-.565.98-1.262.98-.696 0-1.261-.44-1.261-.98 0-.542.565-.98 1.261-.98.697 0 1.262.438 1.262.98z",
    fill: "#aa675d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M357.397 135.082c0 .259-.112.499-.295.628a.498.498 0 0 1-.591 0c-.183-.13-.296-.37-.295-.628 0-.26.112-.5.295-.629a.498.498 0 0 1 .591 0c.183.13.295.37.295.629z",
    fill: "#e2a494"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5d8bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.55 126.38c0 .377-.319.682-.713.682-.395 0-.714-.305-.714-.681 0-.377.32-.682.714-.682.394 0 .714.305.713.682zM332.865 126.63c0 .376-.32.681-.714.681-.394 0-.714-.305-.713-.681 0-.377.319-.682.713-.682.395 0 .714.305.714.682zM330.678 128.306c0 .473-.401.856-.897.856s-.897-.383-.897-.856.401-.857.897-.857.898.384.897.857zM332.76 131.12c0 .377-.32.682-.714.682-.394 0-.714-.305-.713-.681 0-.377.32-.682.713-.682.395 0 .714.305.714.682zM328.596 130.584c0 .376-.32.681-.713.681-.395 0-.714-.305-.714-.681 0-.376.32-.682.714-.682.394 0 .714.306.713.682z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5d8bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.729 127.115c.085.367-.158.736-.542.825-.384.09-.764-.136-.849-.503-.085-.366.157-.736.542-.825.384-.089.764.137.849.503zM311.988 126.384c.085.367-.157.736-.541.825-.385.09-.765-.136-.85-.503-.085-.366.158-.736.542-.825.384-.089.764.137.849.503zM310.236 128.51c.107.461-.198.925-.68 1.037-.484.112-.962-.171-1.068-.632-.107-.46.198-.925.68-1.037.484-.112.961.172 1.068.632zM312.9 130.783c.084.367-.158.736-.542.825-.385.09-.765-.136-.85-.503-.085-.366.158-.736.542-.825.384-.089.765.137.85.503zM308.721 131.2c.086.366-.157.736-.541.825-.384.089-.764-.137-.849-.503-.085-.367.157-.736.541-.825.385-.09.765.136.85.503z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5d8bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.54 131.041c.137.35-.05.751-.418.894-.367.142-.776-.026-.912-.377-.136-.35.051-.751.419-.894.368-.143.776.026.912.377zM293.653 129.711c.136.351-.051.751-.419.894-.367.143-.776-.026-.912-.377-.136-.35.051-.75.419-.894.368-.142.776.027.912.377zM292.221 132.065c.172.441-.064.944-.526 1.123-.462.18-.975-.032-1.146-.473-.172-.441.064-.944.526-1.124.462-.179.975.033 1.146.474zM295.18 133.936c.137.35-.05.751-.418.894-.367.142-.776-.026-.912-.377s.051-.751.419-.894c.368-.143.776.026.912.377zM291.105 134.943c.136.35-.051.75-.419.893-.367.143-.776-.026-.912-.377-.136-.35.051-.75.419-.893.368-.143.776.026.912.377z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5d8bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.283 129.063c-.096.394-.508.631-.921.53-.413-.1-.669-.502-.572-.896.096-.394.509-.631.921-.53.413.1.67.502.572.896zM351.735 130.43c-.096.393-.51.63-.922.53-.413-.102-.669-.503-.572-.897.096-.393.509-.631.922-.53.412.101.669.503.572.896zM349.017 131.623c-.121.495-.64.793-1.158.666-.52-.127-.841-.631-.72-1.126.121-.495.64-.794 1.159-.667.518.127.84.632.719 1.127zM350.474 135.102c-.096.394-.509.632-.922.53-.412-.1-.669-.502-.572-.896.096-.393.509-.63.922-.53.412.101.669.503.572.896zM346.254 133.473c-.096.394-.509.632-.921.53-.413-.1-.67-.502-.573-.896.096-.394.51-.631.922-.53.413.101.669.502.572.896z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M355.973 88.931s-2.05 1.923-4.487 1.923c-2.436 0-3.846-1.025-4.615-1.538-.77-.513.256-2.052.256-2.052",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M312.896 92.777s-3.718-.64-5.257-1.154c-1.538-.512-1.153-1.538-2.948-1.41-1.795.128-3.59 1.41-3.206 3.205.385 1.795 1.667 2.052 2.95 1.667 1.281-.385.897-2.564-.77-2.436-1.667.128-.256 1.539-.256 1.539",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.095
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M287.255 89.957s1.025 1.538 3.718 1.282c2.692-.257 3.718-1.667 3.846-2.308.128-.64 0-1.795-.513-2.308-.513-.512-2.308-.769-2.308-.769",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.043
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#161111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.19 270.402c2.487-2.448 6.486-5.158 8.707-11.048 2.08-5.513 3.087-15.633 4.984-20.762 2.48-8.792 7.474-17.364 1.53-16.778-5.66.56-7.49 6.028-9.635 10.03-.994 1.49-3.283 4.683-3.716 6.497-.087-3.045-1.625-11.926-1.94-20.857-.293-8.341-.056-17.023-.28-20.263-.272-4.277-.244-8.295-1.247-11.456-.467-1.474-2.633-2.89-3.743-2.829-2.281.017-3.66 2.001-3.969 3.865-.222 1.473-.16.936-.31 2.84-.19 2.408.045 5.513-.128 8.239-.187 2.94.197 6.204.037 8.939-.323 5.514-.722 10.566-.885 11.6 0-2.045-.935-11.704-1.247-20.872-.119-3.479-.2-6.908-.261-10.101-.05-2.583.063-5.33-.214-7.336-.473-3.424-1.58-4.983-4.064-4.983-1.675 0-4.073 1.219-4.84 5.026-.413 2.053-.43 4.566-.362 7.31.063 2.55.199 5.298.158 8.057-.155 10.444-.34 21.513-.766 24.774-.069-1.072-1.114-6.536-1.396-13.852-.111-2.882-.268-6.36-.422-9.684-.185-3.975-.17-6.94-.27-9.591-.028-1.602-.665-6.212-3.748-5.935-1.618-.198-3.332.93-4.022 5.293-.384 2.43-.375 6.612-.439 9.835-.121 6.12-.386 11.479-.092 16.927.183 3.4.155 6.02.194 7.695.04.445-.868-2.856-1.327-7.343-.45-4.389-.847-9.976-.811-8.687 0-2.266-.11-5.64-.314-8.424-.16-2.175-.06-4.574-2.418-4.382-2.394.194-3.864 1.003-4.36 5.102-.32 2.655-.408 8.394-.478 10.475.258 5.292-1.156 17.63-1.797 21.138-.175 2.486-1.156 5.72-1.571 9.185-.893 7.46-.044 16.192.944 20.662 1.963 7.056 7.087 10.222 6.83 15.01-.258 4.788 0 13.23 0 17.01 0 3.78 3.283 3.984 10.08 2.52 11.115-2.394 17.188 2.394 26.365-1.134-1.164-10.458 1.104-16.745 1.045-20.525zM332.705 245.69c2.299-6.346 5.202-8.839 8.004-10.223",
    fill: "#c00",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.432 239.148c3.461-1.365 7.055-2.356 10.572-3.558 4.304-1.214 8.472-2.954 12.913-3.642 2.14-.436 4.291-.858 6.474-1.005M301.259 273.007c.484-.32.95.188 1.416.285.652.2 1.334.402 2.022.284 1.35-.022 2.703-.024 4.054.005 1.603-.059 2.93-.117 4.22-1.024M323.012 273.171c.464.381.992.68 1.55.9.859.38 1.798.429 7.368-.02 3.454.221 6.513-2.762 7.375-3.567",
    fill: "none",
    strokeWidth: 1.6
  }))));
};
export default __webpack_public_path__ + "assets/9d02a9ef7513d21187c3981c8d20e3aa.svg";
export { SvgGbNir as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gb-nir.svg